"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Button = require("react-bootstrap/lib/Button");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/** Highlighted actions to select */
var Button = function Button(_ref) {
  var htmlId = _ref.htmlId,
      children = _ref.children,
      size = _ref.size,
      buttonStyle = _ref.buttonStyle,
      block = _ref.block,
      disabled = _ref.disabled,
      href = _ref.href,
      onClick = _ref.onClick,
      type = _ref.type,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["htmlId", "children", "size", "buttonStyle", "block", "disabled", "href", "onClick", "type", "className"]);

  return _react2.default.createElement(
    _Button2.default,
    Object.assign({
      id: htmlId,
      bsSize: size === "default" ? null : size,
      bsStyle: buttonStyle,
      block: block,
      disabled: disabled,
      href: href,
      onClick: onClick,
      type: type,
      className: className
    }, props),
    children
  );
};

Button.propTypes = {
  /** Create block level buttons—those that span the full width of a parent, when set to true. */
  block: _propTypes2.default.bool,

  /** Component visual or contextual style variants. One of `default`, `primary`, `link`, or `danger`.*/
  buttonStyle: _propTypes2.default.oneOf(["success", "warning", "danger", "info", "default", "primary", "link"]),

  /** Any child components. */
  children: _propTypes2.default.node,

  /** Component className. */
  className: _propTypes2.default.string,

  /** Disables the button when set to true. */
  disabled: _propTypes2.default.bool,

  /** Specify the destination URL when clicked. */
  href: _propTypes2.default.string,

  /** Globally unique and descriptive HTML ID. Used by QA for automated testing. */
  htmlId: _propTypes2.default.string.isRequired,

  /** onClick callback. Called with `cb(event)`. */
  onClick: _propTypes2.default.func,

  /** Component size variations. One of `large`, `default`, or `small`. To save typing `lg` or `sm` are accepted as well. */
  size: _propTypes2.default.oneOf(["lg", "large", "default", "sm", "small"]),

  /** Defines HTML button type attribute. One of `button`, `reset`, or `submit` */
  type: _propTypes2.default.oneOf(["button", "reset", "submit"])
};

Button.defaultProps = {
  block: false,
  buttonStyle: "default",
  size: "default"
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/Button/Button.js
// module id = 495
// module chunks = 0